export const isNumber = (val) => !isNaN(parseInt(val)) && isFinite(parseInt(val));